module.exports = __webpack_public_path__ + "img/orangeMarker.387f5dac.svg";